import { render, staticRenderFns } from "./ckdialog.vue?vue&type=template&id=b988629e&scoped=true&"
import script from "./ckdialog.vue?vue&type=script&lang=js&"
export * from "./ckdialog.vue?vue&type=script&lang=js&"
import style0 from "./ckdialog.vue?vue&type=style&index=0&id=b988629e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b988629e",
  null
  
)

export default component.exports